import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const ReplyIcon: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 24, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 14 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.99079 8.44601H11.4846L9.07049 10.8642C8.81311 11.1221 8.81311 11.5488 9.07049 11.8066C9.32787 12.0645 9.75389 12.0645 10.0113 11.8066L13.5614 8.25042C13.8187 7.99259 13.8187 7.56585 13.5614 7.30802L10.0113 3.75181C9.87814 3.61845 9.70951 3.55621 9.54088 3.55621C9.37225 3.55621 9.20362 3.61845 9.07049 3.75181C8.81311 4.00963 8.81311 4.43638 9.07049 4.6942L11.4846 7.11243H5.99079C3.41697 7.11243 1.33129 5.01426 1.33129 2.4449V0.66679C1.33129 0.302278 1.02954 0 0.66565 0C0.301766 0 8.58307e-06 0.302278 8.58307e-06 0.66679V2.4449C8.58307e-06 5.75218 2.6892 8.44601 5.99079 8.44601Z"
        fill="currentColor"
      />
    </svg>
  )
})

ReplyIcon.displayName = 'ReplyIcon'
